import { Webinar } from "./WOWApi.Service";

export class CartObject {
    webinarId?: number;
    cartId?: number;
    productName:string;
    quantity:number;
    cost:number;
    total:number;
    message:string;
    seatNumber: string[] = [];
    seatId: number[] = [];
    seats?: Seats[] = [];
    public pricePerSeat?: number;
    roomName?: string;
}

export class Seats {
    public seatId?: number;
    public seatNumber?: number;
}
